import { useContext } from "react";
import { SlideDataContext } from "../contexts/slideDataContext";

/**
 * Returns the test taker's current streak.
 *
 * Starts at the end of the QuestionContext array, and counts all elements that have $state set to correct after the first encountered element.
 *
 * @listens SlideDataContext
 * @return {number} Streak.
 */
const useStreak = (): number => {
  const { quizSlideDataSequence } = useContext(SlideDataContext);
  let streak = 0;
  for (let i = quizSlideDataSequence.length - 1; i >= 0; i--) {
    const state = quizSlideDataSequence[i].state;
    if (state === "correct") {
      streak++;
    } else if (state === "incorrect") {
      break;
    }
  }
  return streak;
};

export default useStreak;
